import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Loader2 } from "lucide-react";

type userData = {
  familyName: string;
  surName: string;
  emailAddress: string;
};

const RegisterFrom = () => {
  const [formData, setFormData] = useState<userData>({
    familyName: "",
    surName: "",
    emailAddress: "",
  });
  // const [clicked, setClicked] = useState(false);
  const [enableButton, setEnableButton] = useState<any>(false);
  const [isChecked, setIsChecked] = useState<any>(false);

  const apID = window.location.pathname.split("/").at(1);

  useEffect(() => {
    if (enableButton) {
      const timeout = setTimeout(() => {
        window.location.reload();
      }, 10000); 
  
      return () => clearTimeout(timeout); // Limpa o timeout se o componente for desmontado
    }
  }, [enableButton]);
  
  if (!apID?.trim()) {
    return (
      <div className="bg-white p-10 rounded-lg shadow-lg w-full max-w-sm">
        AP NÃO ENCONTRADO
      </div>
    );
  }

  const handleChange = (e: { target: { name: string; value: string } }) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRegister = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setEnableButton(true);
    try {
      const response = await fetch(
        "https://api-wifi-social.redemarajo.tech/register",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...formData,
            apID,
          }),
        }
      );

      const data = await response.json();
      window.location.href = data.redirectUrl;
    } catch (error) {
      console.error(error);
      alert("Erro ao cadastrar usuário.");
    }
  };

  // Funcao de validar email
  const validEmail = (email: string) => {
    const emailRegex = /^[^\s@]{7,}@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isFormValid =
    formData.familyName &&
    formData.surName &&
    formData.emailAddress &&
    validEmail(formData.emailAddress);

  return (
    <div className="bg-white p-10 rounded-lg shadow-lg w-full max-w-sm">
      <img
        src="/logo-wifi.png"
        alt="Logo wi-fi"
        className="mx-auto mb-4 h-28 w-28"
      />

      <div className="App">
        <div className="flex flex-row justify-center ">
          <div>
            <p className="font-medium text-black text-sm">
              Bem-vindo ao WiFi Social "Marajó Connect". Estamos felizes em
              oferecer a você acesso à nossa rede Wi-Fi.
            </p>
          </div>
        </div>
        {/* <form id="registrationForm" onSubmit={handleRegister}> */}
        <form id="registrationForm">
          <div className="pb-4">
            <Label className="font-medium tailwind.config.jstext-black">
              Nome:
              <Input
                type="text"
                name="familyName"
                value={formData.familyName}
                onChange={handleChange}
                required
              />
            </Label>

            <Label className="font-medium tailwind.config.jstext-black">
              Sobrenome:
              <Input
                type="text"
                name="surName"
                value={formData.surName}
                onChange={handleChange}
                required
              />
            </Label>
            <Label className="font-medium tailwind.config.jstext-black">
              Email:
              <Input
                type="email"
                name="emailAddress"
                value={formData.emailAddress}
                onChange={handleChange}
                required
              />
            </Label>
          </div>

          <div className="mb-4 flex items-center">
            <Dialog>
              <DialogTrigger asChild>
                <Button
                  variant="secondary"
                  className="w-full"
                  disabled={!isFormValid}
                >
                  Cadastrar
                </Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-[400px] justify-center mt-[-30px]">
                <DialogHeader>
                  <DialogTitle className="pb-2">
                    Termo de Responsabilidade
                  </DialogTitle>
                  <ScrollArea className="h-[270px] w-[330px] rounded-md border p-2">
                    <p>
                      <strong>TERMO DE USO REDE WI-FI MARAJÓ</strong>
                    </p>
                    <br />

                    <p>
                      <strong>1. Introdução</strong>
                    </p>
                    <br />
                    <p>
                      Bem-vindo ao WiFi Social "Marajó Connect". Ao acessar e
                      utilizar nosso serviço de WiFi, você concorda com os
                      seguintes termos e condições. Por favor, leia atentamente
                      antes de proceder.
                    </p>
                    <br />
                    <p>
                      <strong>2. Consentimento</strong>
                    </p>
                    <p>
                      Ao utilizar o WiFi Social "Marajó Connect", você declara
                      que leu, compreendeu e aceita todos os termos e condições
                      aqui estabelecidos. Se você não concordar com algum dos
                      termos, não utilize o serviço.
                    </p>
                    <br />
                    <p>
                      <strong>3. Responsabilidades do Usuário</strong>
                    </p>
                    <p>
                      3.1. <strong>Uso Responsável:</strong> <br />
                      O Usuário é responsável por todas as atividades realizadas
                      através da rede WiFi utilizando suas credenciais.
                      <br />
                      3.2. <strong>Confidencialidade:</strong>
                      <br /> Mantenha suas credenciais de acesso seguras e não
                      compartilhe com terceiros.
                      <br />
                      3.3. <strong>Proibições:</strong> <br />É estritamente
                      proibido usar a rede WiFi para:
                      <br />
                      - Distribuir conteúdo protegido por direitos autorais sem
                      permissão;
                      <br />
                      - Acessar sistemas e informações sem autorização;
                      <br />
                      - Espalhar vírus ou software malicioso;
                      <br />- Praticar qualquer forma de assédio ou
                      discriminação.
                    </p>
                    <br />

                    <p>
                      <strong>4. Coleta e Uso de Dados</strong>
                    </p>
                    <p>
                      4.1. <strong>Dados Coletados:</strong> Ao utilizar o
                      serviço, poderemos coletar e armazenar informações como:
                      <br />
                      - Nome completo;
                      <br />
                      - Endereço de e-mail;
                      <br />
                      - Número de telefone;
                      <br />
                      - Informações sobre dispositivos utilizados;
                      <br />
                      - Dados de navegação.
                      <br />
                      4.2. <strong>Finalidade:</strong> Os dados coletados serão
                      usados para:
                      <br />
                      - Assegurar a segurança e funcionamento da rede;
                      <br />
                      - Melhorar a qualidade dos nossos serviços;
                      <br />
                      - Enviar informações sobre produtos, serviços, promoções e
                      eventos, se autorizado pelo Usuário;
                      <br />
                      - Realizar análises e estudos de mercado.
                      <br />
                      4.3. <strong>Privacidade:</strong> Garantimos que seus
                      dados pessoais serão tratados de acordo com a Lei Geral de
                      Proteção de Dados Pessoais (LGPD) e não serão vendidos,
                      alugados ou compartilhados com terceiros não autorizados.
                      <br />
                      4.4. <strong>Direitos do Usuário:</strong> Você tem o
                      direito de corrigir ou solicitar a exclusão dos seus dados
                      pessoais. Para isso, entre em contato conosco pelo e-mail:
                      marajoconnect@redemarajo.com.br
                    </p>
                    <br />

                    <p>
                      <strong>5. Monitoramento e Privacidade</strong>
                    </p>
                    <p>
                      5.1. <strong>Monitoramento:</strong> Poderemos monitorar o
                      uso da rede para assegurar a conformidade com estes termos
                      e a legislação vigente.
                      <br />
                      5.2. <strong>Proteção de Dados:</strong> Comprometemo-nos
                      a proteger a privacidade dos usuários, não divulgando
                      informações pessoais, exceto conforme exigido por lei ou
                      com o consentimento do Usuário.
                    </p>
                    <br />

                    <p>
                      <strong>6. Limitação de Responsabilidade</strong>
                    </p>
                    <p>
                      6.1. <strong>Isenção de Responsabilidade:</strong> Não nos
                      responsabilizamos por quaisquer danos resultantes do uso
                      ou da incapacidade de uso do serviço WiFi.
                      <br />
                      6.2. <strong>Garantias:</strong> Não garantimos que o
                      serviço será ininterrupto, seguro ou livre de erros.
                    </p>
                    <br />

                    <p>
                      <strong>7. Aceitação dos Termos</strong>
                    </p>
                    <p>
                      Ao clicar em "Aceito" e utilizar o WiFi Social "Marajó
                      Connect", você concorda com todos os termos e condições
                      estabelecidos.
                    </p>
                    <br />

                    <p>
                      <strong>8. Alterações nos Termos</strong>
                    </p>
                    <p>
                      Reservamo-nos o direito de modificar estes termos a
                      qualquer momento. As alterações serão publicadas e
                      entrarão em vigor imediatamente. O uso contínuo do serviço
                      após a publicação das alterações constitui aceitação das
                      novas condições.
                    </p>
                    <br />

                    <p>
                      <strong>9. Informações de Contato</strong>
                    </p>
                    <p>
                      <strong>Provedor:</strong> Rede Marajó Connect
                      <br />
                      {/* <strong>Endereço:</strong> Rua Exemplo, 123, Bairro
                      Centro, Cidade Exemplo, Estado, CEP 12345-678
                      <br /> */}
                      <strong>E-mail:</strong> marajoconnect@redemarajo.com.br
                      <br />
                      {/* <strong>Telefone:</strong> (00) 1234-5678 */}
                    </p>
                  </ScrollArea>
                </DialogHeader>
                <div className="flex items-center space-x-2">
                  <Checkbox
                    required
                    onCheckedChange={setIsChecked}
                    value={isChecked}
                    id="terms1"
                  />
                  <div className=" w-[310px] ">
                    <Label className="text-xs" htmlFor="terms1">
                      {`Concordo em aceitar todo o conteúdo sobre, a marca 'Rede Marajó'
                        Ao acessar e utilizar a rede Wi-Fi Social "MARAJÓ_GRATIS",
                        certos dados pessoais e de navegação poderão ser coletados e
                        armazenados.
                      `}
                    </Label>
                  </div>
                </div>

                <DialogFooter>
                  {enableButton? (
                    <Button
                      variant="outline"
                      className="w-full"
                      disabled
                    >
                       <Loader2 className="animate-spin" />
                      Cadastrando...
                    </Button>
                  ) : (
                    <Button
                      variant="secondary"
                      className="w-full"
                      onClick={handleRegister}
                      disabled={!isChecked}
                    >
                      Aceitar
                    </Button>
                  )}
                </DialogFooter>
              </DialogContent>
            </Dialog>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterFrom;
